import { Radio as AntRadio } from 'antd';
import styled from 'styled-components';

export const Radio = styled(AntRadio)`
  .ant-radio-checked {
    .ant-radio-inner {
      background-color: var(--clr-container-bg);
      &::after {
        background: var(--clr-general-primary);
      }
    }
  }
`;

export const RadioStyled = styled(AntRadio.Group)`
  .ant-radio-wrapper {
    margin: 0;
    .ant-radio-label {
      padding-inline: 0;
      width: 100%;
    }
    .ant-radio-checked {
      .ant-radio-inner {
        background-color: var(--clr-container-bg);
        &::after {
          background: var(--clr-general-primary);
        }
      }
    }
  }
  &.custom-radio {
    .ant-radio-wrapper {
      flex-direction: row-reverse;
      align-items: center;
    }
  }
`;

export const RadioGroup = styled(AntRadio.Group)`
  /* A viewport-relative cap can't work here: the modal is vertically centred, so the room
     below it is (100vh - modalHeight) / 2 — a value that depends on this list's own height.
     The list's bottom spacing comes from the .scroll-to-modal-edge class. */
  &.settings-ogranisation-selection {
    max-height: 320px;
  }
  &.region-selection {
    max-height: 356px;
  }
  /* Opt-in variant: rows collapse into one card, framed by the container so a scrolling list
     keeps its rounded bottom instead of waiting for the last row to come into view. */
  &.grouped-list {
    gap: 0;
    border: 1px solid var(--clr-border-grey-100);
    border-radius: 5px;
    background-color: var(--clr-container-bg);
    /* A scrollbar strip would leave every row short of the card's own right border. */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .list-section-heading {
      border-bottom: 1px solid var(--clr-border-grey-100);
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }
    .ant-radio-wrapper {
      border: 0;
      border-bottom: 1px solid var(--clr-border-grey-100);
      border-radius: 0;
      padding: 15px;
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      /* A picked or hovered row is marked by its tint alone; the guards match the defaults
         being overridden so these win the specificity tie. */
      &:not(.ant-radio-wrapper-disabled):hover {
        border-color: var(--clr-border-grey-100);
      }
      &:not(.ant-radio-wrapper-disabled):not(.ant-radio-wrapper-checked):hover .ant-radio-inner {
        border-color: var(--clr-border-grey-100);
      }
      &.ant-radio-wrapper-checked {
        border-color: var(--clr-border-grey-100);
      }
    }

    > .ant-radio-wrapper:last-child,
    > :last-child > .ant-radio-wrapper:last-child {
      border-bottom: 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid var(--clr-border-grey-100);
    border-radius: 5px;
    padding: 9px 10px;
    cursor: pointer;
    margin: 0;
    transition: background-color 0.3s ease-in-out;
    background-color: var(--clr-container-bg);
    justify-content: space-between;
    flex-direction: row-reverse;
    /* A row that cannot be picked gives no hover feedback at all, border included. */
    &:not(.ant-radio-wrapper-disabled):hover {
      background-color: var(--clr-general-hover);
      border-color: var(--clr-general-border-hover);
      .ant-radio-inner {
        border-color: var(--clr-general-border-hover);
      }
    }
    &.ant-radio-wrapper-checked {
      border-color: var(--clr-general-primary);
      background-color: var(--selected);
      &:hover {
        background-color: var(--selected-hover);
        .ant-radio-inner {
          border-color: var(--clr-general-primary);
        }
      }
    }
    .ant-radio-label {
      padding: 0;
      width: 100%;
      display: flex;
      align-items: center;
    }
    &::after {
      display: none;
    }
  }
  .ant-radio-wrapper-disabled {
    cursor: not-allowed;
    .ant-radio {
      display: none;
    }
    /* Only the row's content reads as unavailable. Fading the whole row washed out its
       border too, so a disabled row's hairline no longer matched its neighbours'. */
    .radio-card {
      opacity: 0.5;
      .unavailable {
        align-self: flex-start;
        border-radius: 30px;
        background-color: var(--clr-border-grey-100);
        color: var(--clr-subtitle);
        padding: 2px 10px;
        margin-bottom: 6px;
        font-size: 9px;
        font-weight: 500;
        line-height: 12px;
        white-space: nowrap;
        backdrop-filter: blur(10px);
        height: 16px;
      }
    }
  }
  &.semi-disabled {
    .ant-radio-wrapper {
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
      /* The selection stays readable and hoverable, so its lock message can show. */
      &.ant-radio-wrapper-checked {
        opacity: 0.6;
        pointer-events: auto;
      }
    }
  }
  /* The row is picked by clicking anywhere on it, so the circle is hidden; the input stays focusable. */
  &.suggetions-list {
    .ant-radio {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip-path: inset(50%);
    }
    .ant-radio-wrapper:has(.ant-radio-input:focus-visible) {
      outline: 2px solid var(--clr-general-primary);
      outline-offset: -2px;
    }
  }
`;

export const RadioButton = styled(AntRadio.Group)`
  display: flex;
  gap: 10px;
  .ant-radio-wrapper {
    margin: 0;
    border-radius: 5px;
    padding: 11px 10px;
    border: 1px solid var(--clr-border-grey-100);
    flex-direction: row-reverse;
    align-items: center;
    justify-content: left;
    gap: 15px;
    width: 100%;
    .ant-radio-label {
      padding-inline: 0;
      width: 100%;
      display: inline-block;
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      color: var(--clr-title);
    }
    &::after {
      display: none;
    }
    &.ant-radio-wrapper-checked {
      border-color: var(--clr-general-primary);
      background-color: var(--selected);
      &:hover {
        background-color: var(--selected-hover);
        .ant-radio-inner {
          border-color: var(--clr-general-primary);
        }
      }
    }
    &:hover {
      background-color: var(--clr-general-hover);
      .ant-radio-inner {
        border-color: var(--clr-border-grey-100);
      }
    }
  }
`;

// Equal picture columns: the preview and label sit above the circle, and the whole column picks the option.
export const PreviewRadioGroup = styled(AntRadio.Group)`
  display: flex;
  gap: 10px;
  width: 100%;
  .ant-radio-wrapper {
    flex: 1 1 0;
    flex-direction: column-reverse;
    align-items: center;
    gap: 5px;
    min-width: 0;
    margin: 0;
    &::after {
      display: none;
    }
    .ant-radio-label {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 0;
    }
    .option-preview {
      display: flex;
      justify-content: center;
      width: 100%;
      .icon {
        display: contents;
      }
      svg {
        display: block;
        min-width: 0;
        max-width: 100%;
        height: auto;
      }
    }
    &:not(.ant-radio-wrapper-checked) .selection-ring {
      visibility: hidden;
    }
    .ant-radio-checked .ant-radio-inner {
      background-color: var(--clr-container-bg);
      &::after {
        background: var(--clr-general-primary);
      }
    }
  }
`;

// One row of round colour swatches that shrink together in a narrow pane; the radio circle is hidden but its input stays focusable.
export const ColorSwatchRadioGroup = styled(AntRadio.Group)`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
  .ant-radio-wrapper {
    flex: 0 1 42px;
    min-width: 0;
    margin: 0;
    &::after {
      display: none;
    }
    .ant-radio {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip-path: inset(50%);
    }
    .ant-radio-label {
      display: block;
      width: 100%;
      padding: 0;
    }
    &:has(.ant-radio-input:focus-visible) .color-swatch {
      outline: 2px solid var(--clr-general-primary);
      outline-offset: 2px;
    }
  }
  .color-swatch {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    color: var(--clr-white);
    .icon {
      display: contents;
    }
    svg {
      width: 57%;
      height: auto;
    }
  }
`;
